import Store from '@/store/main.js';

Store.watch(
	() => Store.state.base.uiLocale,
	() => {
		Store.dispatch('i18n/loadLanguage', { language: Store.state.base.uiLocale });
	}
);

